import { useMemo } from 'react';

import { useReferenceImageUIStore } from '@/modules/referenceImage';
import { useFloorplanDesignStore } from '@/modules/floorplanDesign/store/useFloorplanDesignStore';

/**
 * @description 
 * Returns true if a reference image is present in the floorplan, but hasn't been scaled yet.
 * 
 * A hook acting like a cross-store selector.
 */
export const useExistsAndIsNotScaledSelector = () => {
  const referenceImage = useFloorplanDesignStore((state) => state.uxonly.referenceImage);
  const origianlDimensions = useReferenceImageUIStore(
    (state) => state.referenceImage.originalDimensions,
  );

  const referenceExistsAndIsNotScaled = useMemo(() => {
    if (!referenceImage || !origianlDimensions) return false;
    if (
      referenceImage.rectangle.width === origianlDimensions.width &&
      referenceImage.rectangle.length === origianlDimensions.height
    ) {
      return true;
    } 

    return false;
  }, [referenceImage, origianlDimensions]);

  return {
    referenceExistsAndIsNotScaled,
  };
};
